import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function collectionReducer(state = initialState.collection, action) {
	switch(action.type) {
		case types.LOAD_COLLECTION_SUCCESS:
			//debugger;
			return action.collection;

		default:
			return state;
	}
}


/** WEBPACK FOOTER **
 ** ./src/reducers/collectionReducer.js
 **/